var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkIcon = function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.604,
    d: "M8.166 14h11.667",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#818097",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.5 19.833H8.168a5.833 5.833 0 0 1 0-11.666h2.334m7 11.666h2.333a5.833 5.833 0 0 0 0-11.666h-2.333"
  })));
};
export { SvgLinkIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC40IiBkPSJNOC4xNjYwMiAxNEwxOS44MzI3IDE0IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuNjA0MTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuNTAwNyAxOS44MzMzSDguMTY3MzJDNC45NDU2NiAxOS44MzMzIDIuMzMzOTggMTcuMjIxNiAyLjMzMzk4IDE0QzIuMzMzOTggMTAuNzc4MyA0Ljk0NTY2IDguMTY2NjMgOC4xNjczMiA4LjE2NjYzSDEwLjUwMDdNMTcuNTAwNyAxOS44MzMzSDE5LjgzNEMyMy4wNTU2IDE5LjgzMzMgMjUuNjY3MyAxNy4yMjE2IDI1LjY2NzMgMTRDMjUuNjY3MyAxMC43NzgzIDIzLjA1NTYgOC4xNjY2MyAxOS44MzQgOC4xNjY2M0gxNy41MDA3IiBzdHJva2U9IiM4MTgwOTciIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";